import ajax from "../../authenticationSafeAjax";
import { contactGroupWith, contactWith } from "../contactsModels";

export function fetchContactGroups(callback) {
    const request = {
        url: "/recorder/api/contact-groups"
    };

    ajax(request, (code, response) => {
        callback(JSON.parse(response).map(group => contactGroupWith({ ...group, 
                                                                      contacts: group.contacts.map(emailAddress => contactWith({ emailAddress })) })));
    });
}



/** WEBPACK FOOTER **
 ** ./src/main/javascript/contacts/actions/fetchContactGroups.js
 **/